module.exports = __webpack_public_path__ + "img/buenos_aires_villa_urquiza.f0e6b203.jpg";